import { RangeEnum } from '../../../model/range.enum';
import { MetricEnum, WindowEnum } from '../../../providers/volatility-cones-provider';

// Opções de período para widgets de Volatilidade (compartilhado)
export const periodOptions = [
  { label: '1M', value: WindowEnum.M1 },
  { label: '3M', value: WindowEnum.M3 },
  { label: '6M', value: WindowEnum.M6 },
  { label: '1Y', value: WindowEnum.Y1 },
];

// Tipos de volatilidade (compartilhado)
export const typeOptions = [
  { label: 'Implied Vol', value: 'implied_vol' },
  { label: 'Realized Vol', value: 'realized_vol' },
];

export const typeHeatmapOptions = [
  { label: 'Implied Vol', value: 'implied_vol' },
  { label: 'Historic', value: 'historic' },
  { label: 'Difference', value: 'difference' },
];

// Tenores/strikes (compartilhado)
export const tenorOptions = [
  { label: '10P', value: MetricEnum.P10 },
  { label: '25P', value: MetricEnum.P25 },
  {
    label: 'ATMF',
    value: MetricEnum.ATMF,
  },
  { label: '25C', value: MetricEnum.C25 },
  { label: '10C', value: MetricEnum.C10 },
  {
    label: 'Put',
    value: 'put-group',
    items: [
      { label: '5P', value: MetricEnum.P5 },
      { label: '15P', value: MetricEnum.P15 },
      { label: '20P', value: MetricEnum.P20 },
      { label: '30P', value: MetricEnum.P30 },
      { label: '35P', value: MetricEnum.P35 },
      { label: '40P', value: MetricEnum.P40 },
    ],
  },
  {
    label: 'Call',
    value: 'call-group',
    items: [
      { label: '5C', value: MetricEnum.C5 },
      { label: '15C', value: MetricEnum.C15 },
      { label: '20C', value: MetricEnum.C20 },
      { label: '30C', value: MetricEnum.C30 },
      { label: '35C', value: MetricEnum.C35 },
      { label: '40C', value: MetricEnum.C40 },
    ],
  },
];

export const RangeOptions = [
  { label: '8H', value: RangeEnum.H8 },
  { label: '1D', value: RangeEnum.D1 },
  { label: '5D', value: RangeEnum.D5 },
  { label: '1M', value: RangeEnum.M1 },
  { label: '3M', value: RangeEnum.M3 },
  { label: '6M', value: RangeEnum.M6 },
  { label: '1Y', value: RangeEnum.Y1 },
];
